import React, { Component } from 'react';

import Banner from "./Banner";
require('dotenv');

export class Home extends Component {
    static displayName = Home.name;

    redirectToLogin() {
        //Query AppUser POST endpoint

        //If denied, redirect to https://dev.workstudy.temple.edu:5005/api/AppUser

        //it will redirect TUlogin

        //app will redirect here, POST request will succeed

        window.location.href = process.env.REACT_APP_API_ENDPOINT + "AppUser";
    }

    render () {
        return (
            <div>
                <h1>Summer Work Study - Beasley School of Law</h1>
                <p>Welcome to the Summer Work Study application used for submitting your summer work study hours.</p>
                <button className="btn btn-primary" onClick={this.redirectToLogin}>Login</button>
            </div>
        );
    }
}
